import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { AuthRedirectService } from '../core/auth/auth-redirect.service'
import { SessionStateService } from '../core/auth/session-state.service'

@Injectable()
export class HttpErrorsInterceptorService implements HttpInterceptor {
    constructor(
        private session: SessionStateService,
        private redirect: AuthRedirectService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next
            .handle(req)
            .pipe(catchError((err) => this.handleHttpError(err, req)))
    }

    private handleHttpError(err: HttpErrorResponse, req: HttpRequest<any>) {
        const reqAuthStateVersion = Number(
            req.headers.get('X-Auth-State-Version') ?? '-1'
        )
        const currentAuthStateVersion = this.session.getAuthStateVersion()

        // Ignore delayed 401 responses from a previous auth state (e.g. old tab/session requests).
        if (reqAuthStateVersion !== currentAuthStateVersion) {
            return throwError(() => err)
        }

        if (err.status === 401 && this.isSessionExpiry(err, req)) {
            this.session.logOut() // session is gone server-side: clear local state
            // Remember the page so login can bring the user back to it
            this.redirect.redirectToLogin(err.error?.error_code === 'ACCOUNT_SUSPENDED' ? 'suspended' : 'expired')
        }

        return throwError(() => err)
    }

    /**
     * Only a 401 on an authenticated API call means the session died. Ignore
     * basic-auth challenges (backend tooling), login/CSRF calls, and 401s seen
     * while nobody is logged in (route guards already handle that case).
     */
    private isSessionExpiry(err: HttpErrorResponse, req: HttpRequest<any>) {
        if (!this.session.isAuthenticated()) {
            return false
        }
        if (err.headers?.has('WWW-Authenticate')) {
            return false
        }
        return !/\/(sanctum\/csrf-cookie|public\/(driver-)?login|public\/first-time-login|broadcasting\/auth)(\?|$|\/)/.test(
            req.url
        )
    }
}
